var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.seckill-icon[data-v-1b058f92] {\n  width: 30px;\n  height: 30px;\n  background: url(" + escape(require("../../assets/img/seckill.png")) + ") no-repeat;\n  background-size: contain;\n  position: absolute;\n  top: 5px;\n  left: 5px;\n  font-size: 10px;\n}\n.seckill-icon i[data-v-1b058f92] {\n  width: 100%;\n  text-align: center;\n  display: block;\n  line-height: 18px;\n  padding-top: 8px;\n  color: #fff;\n  -webkit-transform: rotate(-10deg);\n          transform: rotate(-10deg);\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-1b058f92","scoped":true,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/SeckillIcon/index.vue
// module id = 280
// module chunks = 8